// extracted by mini-css-extract-plugin
export default {"page":"Testimonials_page__2HgtC"};